import React from "react"
import Pulse from './Pulse'

const CircleIcon = ({
  iconSize,
  icon,
  colors,
  selected = false,
  hovered = false,
  pulse = false,
  enabled = true,
  onMouseEnter = () => {},
  onMouseLeave = () => {},
  onClick = () => {},
}) => {
  return (
    <svg
      x={0}
      y={0}
      viewBox={`0 0 56 56`}
      width={iconSize}
      height={iconSize}
      style={{cursor: 'pointer'}}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
    >
      <circle
        cx={28}
        cy={28}
        r={24}
        fill={hovered ? colors.hover.bgcolor : selected ? colors.active.bgcolor : colors.default.bgcolor}
        filter={`drop-shadow( 1px 2px 1px rgba(0, 0, 0, .16))`}
        strokeWidth={2}
        stroke={hovered ? colors.hover.bordercolor : selected ? colors.active.bordercolor : colors.default.bordercolor}
      >
        {pulse && (
          <Pulse
            scale={'1 1; 1.1 1.1; 1 1'}
            translate={'0 0; -2.8 -2.8; 0 0'}
          />
        )}
      </circle>
      <svg x={16} y={16}>
        <image 
          href={icon} 
          filter={hovered ? colors.default.svgColorFilter : selected ? colors.active.svgColorFilter : colors.default.svgColorFilter}
          width={24} 
          height={24}
        />
      </svg>
      {!enabled && (
        <line
          x1={18}
          y1={18}
          x2={38}
          y2={38}
          stroke={colors.default.bgcolor}
          strokeWidth={2}
          strokeLinecap="round"
        />
      )}
    </svg>
  )
}

export default CircleIcon